module.exports = __webpack_public_path__ + "img/point.3eba8694.webp";